export default class BrixTabMenu {
  static init(...parameters) {
    return new BrixTabMenu(...parameters);
  }

  constructor(block) {
    this.menu = block.querySelectorAll('.menu-item');
    this.tabs = block.querySelectorAll('.tab');

    [...this.menu].forEach((item) => {
      item.addEventListener('mouseover', event => this.handleHover(event));
    });

    if (!block.classList.contains('-no-reload')) {
      return;
    }

    [...this.menu].forEach((item) => {
      item.addEventListener('click', event => this.handleMenuClick(event));

      if (window.location.hash === `#${item.dataset.hash}`) {
        const scrollToElement = block.querySelector(`.${block.id}-anchor-${item.dataset.hash}`);
        if (scrollToElement) {
          setTimeout(() => {
            scrollToElement.scrollIntoView();
          }, 200);
        }

        this.setCurrent(item.dataset);
      }
    });

    window.addEventListener('hashchange', () => {
      [...this.menu].forEach((item) => {
        if (window.location.hash === `#${item.dataset.hash}`) {
          this.setCurrent(item.dataset);
        }
      });
    });
  }

  handleMenuClick(event) {
    this.setCurrent(event.target.dataset);
  }

  handleHover(event) {
    const isHovered = event.currentTarget;
    const items = this.menu;

    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      const previous = items[i - 1];
      const currentTab = item.classList.contains('-current');
      const next = items[i + 1];

      if (item === isHovered && !currentTab) {
        if (next && next.classList.contains('-current')) {
          isHovered.setAttribute('style', 'border-right: 1px solid white');
        } else if (previous && previous.classList.contains('-current')) {
          isHovered.setAttribute('style', 'border-left: 1px solid white');
        }
      }
    }
  }

  setCurrent(dataset) {
    if (window.location.hash !== dataset.hash) {
      window.location.hash = dataset.hash;
    } else {
      window.location.hash = '';
    }


    [...this.menu].forEach((item) => {
      if (item.dataset.id === dataset.id) {
        item.classList.add('-current');
      } else {
        item.classList.remove('-current');
      }
    });
    [...this.tabs].forEach((tab) => {
      if (tab.dataset.id === dataset.id) {
        tab.classList.add('-current');
      } else {
        tab.classList.remove('-current');
      }
    });
  }
}

// Register class
if (window.brix && window.brix.registerBlock) {
  window.brix.registerBlock('brix-tab-menu', BrixTabMenu.init);
}
